import { getAvatar } from '$tablet-app/src/app/avatars/functions/getAvatar';
import PegasusAvatar from '$tablet-app/src/app/components/Pegasus/PegasusAvatar';
import { useGetStateVariable } from '$tablet-app/src/app/state_variables';
import { StateVariableNames } from '$tablet-app/src/app/state_variables/state_variable_names';
import { useCommands } from '@akin-home/commands-react';
import { useCallback, useState } from 'react';
import styled from 'styled-components/native';
import { AvatarExpressionCommands, ChatCommand } from '../../../commands/types';

export function ChatAvatar() {
  const [expression, setExpression] = useState('default');

  const { data: avatar_data } = useGetStateVariable(StateVariableNames.AVATAR);

  const avatar_asset = getAvatar(avatar_data);

  useCommands(
    ['set_expression'],
    useCallback((commands: ChatCommand[]) => {
      const expression_command = commands.find(
        (cmd) => cmd.type === 'set_expression'
      );

      if (!expression_command) return;

      setExpression(
        (expression_command as AvatarExpressionCommands).data.expression
      );

      // Set back to default after a specified time
      setTimeout(() => {
        setExpression('default');
      }, 3000);
    }, [])
  );

  if (avatar_asset) {
    return <AvatarImage source={avatar_asset} />;
  }

  return <PegasusAvatar expression={expression} noEvents />;
}

const AvatarImage = styled.Image`
  height: 100%;
  width: 100%;
`;
